<template>
  <label class="input">
    <svg
      class="h-[1em] opacity-50"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <g
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="2.5"
        fill="none"
        stroke="currentColor"
      >
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.3-4.3"></path>
      </g>
    </svg>
    <input
      type="search"
      required
      :placeholder="props.placeholder"
      v-model="inputValue"
    />
  </label>
</template>

<script setup lang="ts">
import { onUnmounted, ref, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  debounce: {
    type: Number,
    default: 400,
  },
  placeholder: {
    type: String,
    default: "Search",
  },
});
const emit = defineEmits(["update:modelValue"]);

const inputValue = ref(props.modelValue);
let timeout: ReturnType<typeof setTimeout> | null = null;

watch(
  () => props.modelValue,
  (val) => {
    inputValue.value = val;
  },
);

watch(inputValue, (val) => {
  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(() => {
    emit("update:modelValue", val);
  }, props.debounce);
});

onUnmounted(() => {
  if (timeout) clearTimeout(timeout);
});
</script>
